import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Card, CardContent } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Athletes = () => {
  const [athletes, setAthletes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAthletes();
  }, []);

  const fetchAthletes = async () => {
    try {
      const response = await axios.get(`${API}/athletes`);
      setAthletes(response.data);
    } catch (error) {
      console.error('Error fetching athletes:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      {/* Hero */}
      <section className="bg-gradient-to-r from-red-600 to-red-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-4" data-testid="athletes-title">Galeria de Craques</h1>
          <p className="text-xl">
            Conheça os talentos que brilharam com a camisa do Pequeninos antes de alcançarem o sucesso profissional
          </p>
        </div>
      </section>

      {/* Athletes Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex justify-center items-center py-20">
              <Loader2 className="animate-spin h-12 w-12 text-red-600" />
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {athletes.map((athlete) => (
                <Card key={athlete.id} className="hover:shadow-xl transition group" data-testid={`athlete-card-${athlete.id}`}>
                  <CardContent className="p-0">
                    <div className="aspect-square overflow-hidden">
                      <img 
                        src={athlete.photo_url} 
                        alt={athlete.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition duration-300"
                        onError={(e) => {
                          e.target.src = 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=400';
                        }}
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="text-xl font-bold text-gray-900 mb-2">{athlete.name}</h3>
                      {athlete.position && (
                        <p className="text-red-600 font-semibold mb-2">{athlete.position}</p>
                      )}
                      {athlete.description && (
                        <p className="text-gray-600 text-sm mb-2">{athlete.description}</p>
                      )}
                      {athlete.clubs_played && (
                        <p className="text-gray-500 text-xs">Clubes: {athlete.clubs_played}</p>
                      )}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Athletes;